<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Pannello Operatore
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5 my-2"
            @click="clickAggiungi"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Attività</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            small
            elevation="1"
            class="ml-10"
            @click="toggleFilters"
          >
            <v-icon color="purple">
              mdi-filter
            </v-icon>
          </v-btn>
        </template>
        <span>Filtri</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="clickChiudi"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text style="overflow-y: auto">
      <v-row class="mt-1" v-if="show_filters">
        <v-col>
          <v-select
            label="Macchina"
            dense
            outlined
            hide-details
            v-model="macchina"
            :items="macchine"
            item-text="des_macchina"
            item-value="id_macchina"
            @change="filtra"
          >
          </v-select>
        </v-col>

        <v-col>
          <v-select
            label="Stato"
            dense
            outlined
            hide-details
            v-model="stato"
            :items="stati"
            item-text="nome"
            item-value="id"
            @change="filtra"
          >
          </v-select>
        </v-col>

        <v-col>
          <v-menu
            v-model="calendario_data_inizio_da"
            :close-on-content-click="false"
            :nudge-right="40"
            min-width="289"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                background-color="#ffffff"
                @change="filtra"
                dense
                outlined
                hide-details
                label="Data Inizio Da"
                class="mb-3"
                v-model="data_inizio_da_search_formatted"
                readonly
                v-on="on"
              >
              </v-text-field>
            </template>
            <v-date-picker
              @change="filtra"
              v-model="data_inizio_da_search"
              no-title
              locale="it"
              first-day-of-week="1"
              @input="calendario_data_inizio_da = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col>
          <v-menu
            v-model="calendario_data_inizio_a"
            :close-on-content-click="false"
            :nudge-right="40"
            min-width="289"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                background-color="#ffffff"
                @change="filtra"
                dense
                outlined
                hide-details
                label="Data Inizio A"
                class="mb-3"
                v-model="data_inizio_a_search_formatted"
                readonly
                v-on="on"
              >
              </v-text-field>
            </template>
            <v-date-picker
              @change="filtra"
              v-model="data_inizio_a_search"
              no-title
              locale="it"
              first-day-of-week="1"
              @input="calendario_data_inizio_a = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-data-table
        :items="lista_tabella"
        :headers="headers"
        show-expand
      >
        <template v-slot:item.stato="{ item }">
          <v-tooltip bottom v-if="item.stato == '0'">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                elevation="1"
                class="start-button"
              >
                <v-icon color="orange">mdi-play</v-icon>
              </v-btn>
            </template>
            <span>In corso</span>
          </v-tooltip>

          <v-tooltip bottom v-else-if="item.stato == '1'">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                elevation="1"
                color="purple"
              >
                <v-icon color="white">mdi-minus-thick</v-icon>
              </v-btn>
            </template>
            <span>Sospesa</span>
          </v-tooltip>

          <v-tooltip bottom v-else-if="item.stato == '2'">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                elevation="1"
                color="success"
              >
                <v-icon color="white">mdi-check-bold</v-icon>
              </v-btn>
            </template>
            <span>Completata</span>
          </v-tooltip>
        </template>

        <template v-slot:item.aggiungi="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                elevation="1"
                @click="aggiungiAttivita(item)"
              >
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Attività</span>
          </v-tooltip>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td
            :colspan="headers.length"
            class="pa-0"
            style="background-color: white;"
          >
            <v-data-table
              :headers="subHeaders"
              :items="item.attivita"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:item.stato="{ item }">
                <v-tooltip bottom v-if="item.stato == '0'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      x-small
                      elevation="1"
                      class="start-button"
                    >
                      <v-icon color="orange">mdi-play</v-icon>
                    </v-btn>
                  </template>
                  <span>In corso</span>
                </v-tooltip>

                <v-tooltip bottom v-else-if="item.stato == '1'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      x-small
                      elevation="1"
                      color="purple"
                    >
                      <v-icon color="white">mdi-minus-thick</v-icon>
                    </v-btn>
                  </template>
                  <span>Sospesa</span>
                </v-tooltip>

                <v-tooltip bottom v-else-if="item.stato == '2'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      x-small
                      elevation="1"
                      color="success"
                    >
                      <v-icon color="white">mdi-check-bold</v-icon>
                    </v-btn>
                  </template>
                  <span>Sospesa</span>
                </v-tooltip>
              </template>

              <template v-slot:item.modifica="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      elevation="1"
                      @click="modificaAttivita(item)"
                    >
                      <v-icon color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Modifica Attività</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "PannelloOperatore",
  props: {
    macchine: { type: Array, default: () => [] },
  },
  data() {
    return {
      headers: [
        {
          text: 'Macchina',
          value: 'macchina',
        },
        {
          text: 'Codice intervento',
          value: 'cod_intervento',
        },
        {
          text: 'Stato',
          value: 'stato',
        },
        {
          text: 'Inizio',
          value: 'data_inizio',
        },
        {
          text: 'Fine',
          value: 'data_fine',
        },
        {
          text: 'Durata',
          value: 'durata',
        },
        {
          text: '',
          value: 'aggiungi',
          sortable: false,
        },
      ],
      subHeaders: [
        {
          text: '#',
          value: 'id',
        },
        {
          text: 'Inizio',
          value: 'data_inizio',
        },
        {
          text: 'Fine',
          value: 'data_fine',
        },
        {
          text: 'Stato',
          value: 'stato',
        },
        {
          text: '',
          value: 'modifica',
          sortable: false,
        },
      ],
      listaInterventi: [],
      lista_tabella: [],
      show_filters: false,

      macchina: 'tutte',

      stato: 'tutti',
      stati: [],

      calendario_data_inizio_da: false,
      calendario_data_inizio_a: false,
      data_inizio_da_search: "",
      data_inizio_a_search: "",
      data_inizio_da_search_formatted: "",
      data_inizio_a_search_formatted: "",
    };
  },
  watch: {
    data_inizio_da_search(val) {
      this.data_inizio_da_search_formatted = this.formatDate(val);
    },
    data_inizio_a_search(val) {
      this.data_inizio_a_search_formatted = this.formatDate(val);
    },
  },
  mounted() {
    this.stati = [
      {
        id: 'tutti',
        nome: 'Tutti',
      },
      {
        id: '1',
        nome: 'In corso',
      },
      {
        id: '2',
        nome: 'Sospesa',
      },
      {
        id: '3',
        nome: 'Completata',
      },
    ];

    this.listaInterventi = [
      {
        id: '1',
        id_macchina: '1',
        macchina: 'M01',
        cod_intervento: 'C01',
        stato: '0',
        data_inizio: '27/01/21',
        data_fine: '',
        durata: '',
        attivita: [
          {
            id: '1',
            data_inizio: '27/01/21 12:00',
            data_fine: '27/01/21 12:30',
            stato: '1',
          },
          {
            id: '2',
            data_inizio: '30/01/21 14:00',
            data_fine: '30/01/21 18:00',
            stato: '1',
          },
          {
            id: '3',
            data_inizio: '07/02/21 14:00',
            data_fine: '',
            stato: '0',
          },
        ],
      },
      {
        id: '2',
        id_macchina: '1',
        macchina: 'M01',
        cod_intervento: 'C07',
        stato: '1',
        data_inizio: '17/06/21',
        data_fine: '',
        durata: '7',
      },
      {
        id: '3',
        id_macchina: '2',
        macchina: 'M02',
        cod_intervento: 'C03',
        stato: '2',
        data_inizio: '17/07/21',
        data_fine: '17/07/21',
        durata: '2',
      },
    ];

    this.lista_tabella = this.listaInterventi;
  },
  methods: {
    clickChiudi() {
      this.show_filters = false;

      this.data_inizio_da_search = "";
      this.data_inizio_a_search = "";
      this.data_inizio_da_search_formatted = "";
      this.data_inizio_a_search_formatted = "";

      this.$emit("click_chiudi");
    },
    clickAggiungi() {
      this.$emit("click_aggiungi_intervento");
    },
    toggleFilters() {
      this.show_filters = !this.show_filters;
    },
    filtra() {
      this.lista_tabella = this.listaInterventi;

      if (this.macchina != null && this.macchina != "tutte") {
        this.lista_tabella = this.lista_tabella.filter((el) => {
          return el.id_macchina == this.macchina;
        });
      }

      if (this.stato != null && this.stato != "tutti") {
        this.lista_tabella = this.lista_tabella.filter((el) => {
          return el.stato == this.stato;
        });
      }

      if (this.data_inizio_da_search != '') {
        this.lista_tabella = this.lista_tabella.filter((el) => {
          return moment(el.data_inizio, "DD/MM/YY") >= moment(this.data_inizio_da_search);
        });
      }

      if (this.data_inizio_a_search != '') {
        this.lista_tabella = this.lista_tabella.filter((el) => {
          return moment(el.data_inizio, "DD/MM/YY") <= moment(this.data_inizio_a_search);
        });
      }
    },
    formatDate(date) {
      if (!date) {
        return null;
      }

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    aggiungiAttivita() {

    },
  },
};
</script>

<style scoped>
.start-button {
  border: 4px dashed orange;
  background: white !important;
}
</style>
